// Centralized auth utilities — JWT-based session management
import { getAuthToken, clearAuthToken } from '@/services/apiClient';

export function isAuthenticated(): boolean {
  return !!getAuthToken();
}

export function getCurrentUserEmail(): string | null {
  const token = getAuthToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.sub || payload.email || null;
  } catch {
    return null;
  }
}

export function getCurrentUserName(): string | null {
  const token = getAuthToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.name || payload.displayName || null;
  } catch {
    return null;
  }
}

export function logout() {
  clearAuthToken();
  localStorage.removeItem('smplify_tenant_id');
  window.location.href = '/login';
}

export function isTokenExpired(): boolean {
  const token = getAuthToken();
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

export function getCurrentTenantId(): string | null {
  const token = getAuthToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.tenantId || null;
  } catch {
    return null;
  }
}
